import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import * as S from "./PathologyItem.style";
import * as P from "../../../../../../../utils/pipes";

// Hooks

import { useQuery } from "@apollo/client";

import { QUERY_GET_ALL_DEVICES } from "../../../../../../../graphql/queries/Devices";

function PathologyItem({
  pathology,
  added
}) {

  const { t, i18n: { language } } = useTranslation("global");

  return (
    <S.PathologyItem
      active={added}
    >
      <i className={`device-addition-icon icon ${added ? "zaia-i-remove" : "zaia-i-add-1"}`}></i>
      <div className="device-info">
        <div className="device-info__name">
          {P.dataTranslation(pathology?.name, language)}
        </div>
      </div>
    </S.PathologyItem>
  );
}




export default PathologyItem;
